export default "__VITE_ASSET__Bri9WfV2__"